export default __webpack_public_path__ + "100b62e6cdefd9594afb95641fb43e6f.svg";